var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content", on: { click: _vm.closeCalendar } },
    [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              { staticClass: "w-75 datesDrugSearchBlock" },
              [_c("DrugSearchNew", { attrs: { onSelect: _vm.onDrugSelect } })],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-success ladda-button",
                      "data-style": "zoom-in",
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.showDates()
                      },
                    },
                  },
                  [_vm._v("Показать\n          ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row m-0" }, [
            _c("div", { staticClass: "form-group col-md-6" }, [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showWithComments,
                      expression: "showWithComments",
                    },
                  ],
                  attrs: { type: "checkbox", id: "ch_4" },
                  domProps: {
                    checked: Array.isArray(_vm.showWithComments)
                      ? _vm._i(_vm.showWithComments, null) > -1
                      : _vm.showWithComments,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.showWithComments,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.showWithComments = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.showWithComments = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.showWithComments = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "pointer", attrs: { for: "ch_4" } },
                  [_vm._v("Показать препараты с комментариями")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.expBefore,
                        expression: "expBefore",
                      },
                    ],
                    attrs: { type: "checkbox", id: "ch_3" },
                    domProps: {
                      checked: Array.isArray(_vm.expBefore)
                        ? _vm._i(_vm.expBefore, null) > -1
                        : _vm.expBefore,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.expBefore,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.expBefore = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.expBefore = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.expBefore = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "pointer", attrs: { for: "ch_3" } },
                    [_vm._v("Показать препараты со сроками годности до")]
                  ),
                  _vm._v(" "),
                  _c("datepicker", {
                    ref: "calendar",
                    attrs: {
                      language: _vm.locality,
                      "monday-first": true,
                      "input-class": "form-control",
                      format: "dd.MM.yyyy",
                    },
                    model: {
                      value: _vm.expDate,
                      callback: function ($$v) {
                        _vm.expDate = $$v
                      },
                      expression: "expDate",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "letters_block" },
            _vm._l(_vm.rusArr, function (letter) {
              return _c(
                "button",
                {
                  class: {
                    btn: true,
                    "btn-info": letter != _vm.currentLetter,
                    "btn-primary": letter == _vm.currentLetter,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.searchByLetter(1, letter)
                    },
                  },
                },
                [_vm._v("\n          " + _vm._s(letter) + "\n        ")]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _vm.drugs
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-sm table-hover" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.drugs, function (drug, index) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                index +
                                  1 +
                                  (_vm.paginator && _vm.paginator.current_page
                                    ? _vm.paginator.current_page *
                                        _vm.paginator.per_page -
                                      _vm.paginator.per_page
                                    : 0)
                              ) + "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("p", [
                                _vm._v(_vm._s(drug.id) + " "),
                                _vm.salesData[drug.id]
                                  ? _c("span", [
                                      _vm._v("Продажи: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              _vm.salesData[drug.id] / 3
                                            ).toFixed(1)
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(drug.title))]),
                              _vm._v(" "),
                              _vm.inStores[drug.id] ? _c("hr") : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                _vm.inStores[drug.id],
                                function (storeData) {
                                  return _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$AllStores[storeData.store_id]
                                            .title
                                        ) +
                                        ": "
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(storeData.qty)),
                                    ]),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("expireDateManage", {
                                ref: "expireDateManage",
                                refInFor: true,
                                attrs: {
                                  drugId: drug.id,
                                  dates: drug.valid_dates,
                                  options: _vm.options,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 8,
                            "margin-pages": 3,
                            "click-handler": _vm.searchByLetter,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Срок годности препаратов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { attrs: { width: "33%" } }, [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сроки годности")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }